export const numberSystemDecimal = 10;
export const webApi = 'https://' + import.meta.env.WEB_API;
export const popUpSizes: string[] = ['small', 'medium', 'large'];
export const activationClasses = {active: 'active', activeFlex: 'active-flex'};
export const hiddenClasses = {hidden: 'hidden'};
export const disabledElement = {disabled: 'disabled'};
export const numberConnections: number[] = [3, 5, 10];
export const currentUrl = new URL(window.location.href);
export const searchParams = new URLSearchParams(currentUrl.search);
export const maximumNumber = 9007199254740991;
